module.exports = __webpack_public_path__ + "static/media/tab-back.41c3dbb7.png";